import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { Avatar, Menu, PlainButton } from "@jugl-web/ui-components";
import { EntityModel } from "@jugl-web/rest-api";
import { ReactComponent as OptionsIcon } from "./assets/options.svg";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";
import { ReactComponent as AdminIcon } from "./assets/admin.svg";

export const EntityTile: React.FC<{
  entity: EntityModel;
  onDelete: () => void;
  onManageAdmins: () => void;
}> = ({ entity, onManageAdmins, onDelete }) => {
  const { t } = useTranslations();

  return (
    <div className="bg-grey-100 flex items-center justify-between rounded-2xl py-3 px-4">
      <div className="flex items-center gap-3">
        <Avatar imageUrl={entity.logoImg} username={entity.name} size="md" />
        <div className="font-secondary flex flex-col gap-0.5 text-left text-sm leading-[21px] tracking-[0.14px]">
          <span className="text-dark font-medium">{entity.name}</span>
          <span className="text-[#828282]">
            {t(
              {
                id: "manage-workspace-admins-dialog-component.members-count",
                defaultMessage:
                  "{count} {count, plural, one {Member} other {Members}}",
              },
              { count: entity.userCount }
            )}
          </span>
        </div>
      </div>
      <Menu
        placement="bottom-end"
        autoPosition
        autoClose
        sections={[
          [
            {
              id: "manage-admins",
              label: t({
                id: "manage-workspace-admins-dialog-component.manage-admins",
                defaultMessage: "Manage Admins",
              }),
              icon: <AdminIcon />,
              onSelect: onManageAdmins,
            },
            {
              id: "delete-workspace",
              label: t({
                id: "manage-workspace-admins-dialog-component.delete-workspace",
                defaultMessage: "Delete Workspace",
              }),
              icon: <TrashIcon />,
              onSelect: onDelete,
            },
          ],
        ]}
        renderTrigger={({ Trigger, triggerRef }) => (
          <Trigger as={PlainButton} ref={triggerRef}>
            <OptionsIcon />
          </Trigger>
        )}
      />
    </div>
  );
};
